import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { Store } from "../utils/storage";

const storage = Store("session");

// Define initial State
const State = {
  connectionError: false,
  satelliteView: false,
  showUserLocation: false,
  notificationToken: null,
  notificationSubscription: { show: false, type: "" },
  googleApiKey: null,
  firebaseVapidKey: null,
  webInstaller: {
    installed: false,
  },
};

// Define actions
const Actions = (_set, get) => {
  const set = _set;
  // set connection error
  const setConnectionError = (error) => {
    set({ connectionError: error });
  };

  const toggleSatelliteView = () => {
    set({ satelliteView: !get().satelliteView });
  };

  const toggleShowUserLocation = () => {
    set({ showUserLocation: !get().showUserLocation });
  };
  // Set notification token
  const setNotificationToken = (token) => {
    set({ notificationToken: token });
  };

  // Set notification subscription
  const setNotificationSubscription = ({ show, type }) => {
    set({ notificationSubscription: { show, type } });
  };

  // Set the Google Maps API key
  const setGoogleApiKey = (key) => {
    set({ googleApiKey: key });
  };

  const setFirebaseVapidKey = async (key) => {
    set({ firebaseVapidKey: key });
  };

  const setWebInstaller = (installerState) => {
    set({ webInstaller: { ...get().webInstaller, ...installerState } });
  };

  return {
    setConnectionError,
    toggleSatelliteView,
    toggleShowUserLocation,
    setNotificationToken,
    setNotificationSubscription,
    setGoogleApiKey,
    setFirebaseVapidKey,
    setWebInstaller,
  };
};

// Create Zustand store
const AppSettings = create(
  persist(
    (set, get) => {
      const actions = Actions(set, get);
      return {
        ...State,
        setConnectionError: actions.setConnectionError,
        toggleSatelliteView: actions.toggleSatelliteView,
        toggleShowUserLocation: actions.toggleShowUserLocation,
        setNotificationToken: actions.setNotificationToken,
        setNotificationSubscription: actions.setNotificationSubscription,
        setGoogleApiKey: actions.setGoogleApiKey,
        setFirebaseVapidKey: actions.setFirebaseVapidKey,
        setWebInstaller: actions.setWebInstaller,
      };
    },
    {
      name: "app.global",
      storage: createJSONStorage(() => storage),
    }
  )
);

export default AppSettings;
